export default __webpack_public_path__ + "static/projektuebersicht-3b0d0cca7e33df5e55e7b68d779cc633.jpg";